import { Skeleton } from "@/components/ui/skeleton";

export const HeroSkeleton = () => (
  <section className="bg-card">
    <div className="max-w-6xl mx-auto container-padding section-padding">
      <div className="flex flex-col-reverse md:flex-row items-center justify-between gap-10 md:gap-12">
        <div className="flex-1 max-w-2xl space-y-5">
          <Skeleton className="h-14 w-3/4 rounded-lg" />
          <Skeleton className="h-5 w-full rounded-lg" />
          <Skeleton className="h-5 w-5/6 rounded-lg" />
          <div className="flex gap-3 pt-3">
            <Skeleton className="h-10 w-36 rounded-full" />
            <Skeleton className="h-10 w-32 rounded-full" />
          </div>
        </div>
        <Skeleton className="size-52 md:size-60 lg:size-64 rounded-2xl" />
      </div>
    </div>
  </section>
);

export const SkillsSkeleton = () => (
  <section className="section-padding bg-background">
    <div className="max-w-6xl mx-auto container-padding">
      <Skeleton className="h-10 w-48 mb-3 rounded-lg" />
      <Skeleton className="h-5 w-72 mb-10 rounded-lg" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="p-5 border border-border rounded-xl bg-card">
            <Skeleton className="h-6 w-32 mb-4 rounded-lg" />
            <div className="flex flex-wrap gap-2">
              {[...Array(4)].map((_, j) => (
                <Skeleton key={j} className="h-7 w-20 rounded-full" />
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ProjectsSkeleton = () => (
  <section className="section-padding bg-card">
    <div className="max-w-6xl mx-auto container-padding">
      <Skeleton className="h-10 w-56 mb-3 rounded-lg" />
      <Skeleton className="h-5 w-80 mb-10 rounded-lg" />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="border border-border rounded-xl overflow-hidden bg-background">
            <Skeleton className="aspect-[16/9]" />
            <div className="p-5 space-y-3">
              <Skeleton className="h-5 w-3/4 rounded-lg" />
              <Skeleton className="h-4 w-full rounded-lg" />
              <div className="flex gap-1.5">
                {[...Array(3)].map((_, j) => (
                  <Skeleton key={j} className="h-6 w-16 rounded-full" />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ExperienceSkeleton = () => (
  <section className="section-padding bg-background">
    <div className="max-w-6xl mx-auto container-padding">
      <Skeleton className="h-10 w-48 mb-3 rounded-lg" />
      <Skeleton className="h-5 w-64 mb-10 rounded-lg" />
      <div className="space-y-8">
        {[...Array(3)].map((_, i) => (
          <div key={i} className="pl-5 border-l-2 border-border">
            <Skeleton className="h-3 w-24 mb-2 rounded" />
            <Skeleton className="h-6 w-64 mb-2 rounded-lg" />
            <Skeleton className="h-4 w-full mb-2 rounded-lg" />
            <Skeleton className="h-4 w-5/6 rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const EducationSkeleton = () => (
  <section className="section-padding bg-background">
    <div className="max-w-6xl mx-auto container-padding">
      <Skeleton className="h-10 w-64 mb-3 rounded-lg" />
      <Skeleton className="h-5 w-80 mb-10 rounded-lg" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {[...Array(4)].map((_, i) => (
          <div key={i} className="p-5 border border-border rounded-xl bg-card">
            <div className="flex items-start gap-4">
              <Skeleton className="size-11 rounded-xl" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-5 w-3/4 rounded-lg" />
                <Skeleton className="h-4 w-1/2 rounded-lg" />
                <Skeleton className="h-6 w-20 rounded-full" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export const ContactSkeleton = () => (
  <section className="section-padding bg-card">
    <div className="max-w-6xl mx-auto container-padding">
      <Skeleton className="h-10 w-40 mb-3 rounded-lg" />
      <Skeleton className="h-5 w-72 mb-10 rounded-lg" />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="p-4 border border-border rounded-xl bg-background">
            <div className="flex items-start gap-3">
              <Skeleton className="size-10 rounded-lg" />
              <div className="flex-1 space-y-2">
                <Skeleton className="h-4 w-20 rounded-lg" />
                <Skeleton className="h-4 w-32 rounded-lg" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
